import '../scss/app.scss';
(function ($, root, undefined) {
  $(function () {
    var $window = $(window),
      $body = $('body'),
      $sidebarMenu = $('#sidebarMenu'),
      $openSidebarMenu = $('#openSidebarMenu'),
      $closeSidebarMenu = $('#closeSidebarMenu'),
      $overlay = $('#overlay'),
      $openSearchForm = $('#openSearchForm'),
      $closeSearch = $('#closeSearch'),
      $searchInput = $('.search-input'),
      $navigation = $('.navigation');

    $('.nav-item-has-children > a').on('click', (e) => {
      var $item = $(e.target);
      var $parent = $item.parent();

      if ($item.hasClass('active')) {
        $item.removeClass('active');
        $parent.find('> .sub-menu .sub-menu').fadeOut();
        $parent.find('> .sub-menu').fadeOut();
      } else {
        if ($item.parent().parent().hasClass('sub-menu')) {
          $item.addClass('active');
          $parent.find('> .sub-menu').fadeIn();
          $item.next('.sub-menu').addClass('sub-menu-active');
          return false;
        }
        $('#menu>li>ul.sub-menu').hide();
        $('#menu li a').removeClass('active');
        $item.addClass('active');
        $parent.find('> .sub-menu').fadeIn();
      }
      return false;
    });

    $openSidebarMenu.click(function () {
      $body.addClass('is-menu-visible');
      $sidebarMenu.css(
        {
          transform: 'translate(0%, 0px)',
          display: 'block',
        },
        3000
      );
    });

    $closeSidebarMenu.click(function () {
      $body.removeClass('is-menu-visible');
      $sidebarMenu.css(
        {
          transform: 'translate(100%, 0px)',
          display: 'none',
        },
        3000
      );
    });

    $overlay.on('click', (e) => {
      $body.removeClass('is-menu-visible');
      $sidebarMenu.css(
        {
          transform: 'translate(100%, 0px)',
          display: 'none',
        },
        3000
      );
    });

    $openSearchForm.click(function () {
      $searchInput.css('display', 'flex');
      $navigation.css('display', 'none');
    });

    $closeSearch.click(function () {
      $searchInput.css('display', 'none');
      $navigation.css('display', 'flex');
      $('.search-input').parent().find('input[type="search"]').val('');
    });

    $body.on('click', (e) => {
      if (
        !$(e.target).closest('.search-input').length &&
        !$(e.target).closest('#openSearchForm').length &&
        !$(e.target).closest('.active').length
      ) {
        $searchInput.css('display', 'none');
        $navigation.css('display', 'flex');
        $('.nav-item-has-children > a').removeClass('active');
        $('.sub-menu').fadeOut();
      }
    });

    function handleClassOnResize() {
      if ($(window).width() > 768) {
        $body.removeClass('is-menu-visible');
        $sidebarMenu.css(
          {
            transform: 'translate(100%, 0px)',
            display: 'none',
          },
          3000
        );
      }
    }

    $(document).ready(function () {
      handleClassOnResize();
      $(window).on('resize', handleClassOnResize);
      $('input.search-field').attr('value', '');
    });
  });
})(jQuery, this);
